import { getAuthAxiosBackend } from "../../helpers/axios"

class InjuryServices{

    get(id){
        return getAuthAxiosBackend().get('taskeen/woundeds/'+id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('taskeen/woundeds', {params: data})
    }

    delete(id){
        return getAuthAxiosBackend().delete('taskeen/woundeds/' + id)
    }
}

export default new InjuryServices()